<template>
    <div class="modal-container-cont" v-if="!isLoading && currentPrioritySuggestions.length > 0">
        <div class="modal-container">
            <div class="modal-title">
                <!-- <h2 v-text="getString('combina_com_seu_pedido')"></h2> -->
                <h2 v-text="currentSuggestion ? currentSuggestion.question : ''"></h2>
            </div>
            <div class="body-container">
                <div class="group-container">
                    <div class="prod-cards">
                        <template v-for="suggGroup in productSuggestions">
                            <div class="prod_item prod_item--product"
                                v-for="(suggest, key) in suggGroup.products.slice(0, 3)"
                                :key="suggGroup.groupCode + '-' + suggGroup.question + '-' + suggest.productCode + '-' + key"
                                @click="suggestChoose(suggest, suggGroup.groupCode, suggGroup.question)">
                                <div class="img_container">
                                    <img v-if="suggest.productImages && suggest.productImages.small"
                                        :src="getImagesURL(suggest, 'productImages', 'small')" alt="">
                                    <img v-else :src="noImageSrc">
                                </div>
                                <div class="name_container">
                                    <div class="container">
                                        <span class="name" v-text="getProductLanguage(suggest, 'productName')"></span>
                                    </div>
                                </div>
                                <div class="price_container">
                                    <div class="container">
                                        <span class="from" v-if="exibApartir(suggest)">{{ getString('a_partir_de') }}</span>
                                        <span class="price" v-text="getMinPrice(suggest)"></span>
                                    </div>
                                </div>
                                <div class="action_container">
                                    <button class="btn-add" @click.stop="suggestChoose(suggest, suggGroup.groupCode, suggGroup.question)">
                                        {{ getString('adicionar') }}
                                    </button>
                                </div>
                            </div>
                        </template>
                        <div class="prod_item"
                            v-for="(group, key) in groupSuggestions" :key="group.groupCode + '-' + group.question + '-g-' + key"
                            @click="chooseGroup(group)">
                            <div class="img_container">
                                <img v-if="group.groupImages && group.groupImages.small"
                                    :src="getImagesURL(group, 'groupImages', 'small')" alt="">
                                <img v-else :src="noImageSrc">
                            </div>
                            <div class="name_container">
                                <div class="container">
                                    <span class="name" v-text="getProductLanguage(group, 'groupName')"></span>
                                </div>
                            </div>
                            <div class="price_container">
                                <!-- <div class="container">
                                    <span class="from">{{ getString('a_partir_de') }}</span>
                                    <span class="price" v-text="getGroupMinPrice(group)"></span>
                                </div> -->
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="footer">
                <DefaultButton :text="getString('nao_obrigado')" outlined="true"
                    @defaultBtnClick="noMoreSuggestions"></DefaultButton>
            </div>
        </div>
    </div>
</template>

<script>
import LocaleController from '@/assets/controllers/LocaleController'
import Util from '@/assets/libs/util'
import MinPriceController from '@/assets/controllers/MinPriceController'
import SuggestionsController from '@/assets/controllers/SuggestionsController'
import DefaultButton from '@/components/DefaultButton'
import ClarityController from '../../assets/controllers/ClarityController'

export default {
    name: 'SuggestionsMenuModal',
    components: {
        DefaultButton
    },
    data () {
        return {
            noImageSrc: null,
            junk: '/static/icons/junk-icon.png',
            suggestions: [],
            ignoreNextSuggestions: false,
            currentPrioritySuggestions: [],
            isLoading: true
        }
    },
    props: [
        'productCode',
        'groupCode',
        'indexCart'
    ],
    mounted () {
        this.noImageSrc = Util.getConfigImage('noImage') ? Util.getConfigImage('noImage') : this.junk
        this.getSuggestions()
        this.ignoreNextSuggestions = this.checkIfIgnoreAllSuggestions()
    },
    methods: {
        getString: function (key) {
            return LocaleController.getString(key)
        },
        getImagesURL: function (prod, prop, size) {
            return Util.getImagesUrl(prod, prop, size)
        },
        exibApartir: function (suggest) {
            return Util.exibApartir() && Util.variablePrice(suggest)
        },
        getMinPrice: function (suggest) {
            return MinPriceController.getMinPrice(suggest)
        },
        getGroupMinPrice: function (group) {
            if (!group.products || group.products.length === 0) return ''
            const prices = group.products.map(p => p.fullPrice).filter(price => price > 0)
            if (prices.length === 0) return ''
            return Util.formatMoney(Math.min(...prices))
        },
        exibApartirGroup: function (group) {
            return Util.exibApartir() && group.products && group.products.some(p => Util.variablePrice(p))
        },
        suggestChoose: function (prod, groupCode, question) {
            prod.productSuggested = true
            SuggestionsController.setProductGroupSuggested(groupCode, question)
            this.$emit('handleSuggestion', prod, false)
            ClarityController.event('usuario_aceitou_sugestao_produto_menu')
            ClarityController.setTag('sugestao_produto_menu_aceita', prod.productName)

            // Sempre fecha o modal após selecionar um produto
            // Ele irá reabrir automaticamente com a próxima prioridade quando o usuário retornar
            this.$emit('closeSuggestionsMenuModal')
        },
        getProductLanguage: function (product, index) {
            return LocaleController.getIndexLanguages(product, index)
        },
        getSuggestions: async function () {
            this.suggestions = await SuggestionsController.getSuggestions(
                this.groupCode, this.productCode, this.indexCart
            )

            // Se não há sugestões, significa que o fluxo não pode iniciar (está bloqueado ou concluído)
            if (this.suggestions.length === 0) {
                this.$emit('closeSuggestionsMenuModal')
                return
            }

            this.currentPrioritySuggestions = SuggestionsController.getCurrentPrioritySuggestions()

            if (this.currentPrioritySuggestions.length === 0) {
                SuggestionsController.setIgnoreAllSuggestions(true)
                SuggestionsController.markSuggestionsShown(this.indexCart)
                // Fluxo terminou, reseta o controller antes de fechar
                SuggestionsController.resetSuggestionsController()
                this.$emit('closeSuggestionsMenuModal')
                return
            }

            // Só renderiza o modal se houver sugestões válidas
            this.isLoading = false
        },
        checkIfIgnoreAllSuggestions: function () {
            return SuggestionsController.checkIfIgnoreAllSuggestions()
        },
        noMoreSuggestions: function () {
            // Ignora todas as sugestões restantes e reseta o fluxo
            SuggestionsController.cancelAllSuggestions(this.indexCart)
            ClarityController.event('usuario_rejeitou_sugestao_menu')
            this.$emit('closeSuggestionsMenuModal')
        },
        chooseGroup: function (group) {
            // Salva o grupo como pendente - será marcado como aceito quando um produto for adicionado
            SuggestionsController.setPendingGroupSuggestion(group.groupCode, group.question)
            ClarityController.event('usuario_aceitou_sugestao_grupo_menu')
            ClarityController.setTag('sugestao_grupo_menu_aceita', group.groupName)
            this.$emit('navigateToGroup', group.groupName)
            this.$emit('closeSuggestionsMenuModal')
        }
    },
    computed: {
        currentSuggestion () {
            // Retorna a primeira sugestão para o texto da pergunta
            return this.currentPrioritySuggestions[0] || null
        },
        productSuggestions () {
            return this.currentPrioritySuggestions.filter(s => !s.isGroupSuggestion)
        },
        groupSuggestions () {
            return this.currentPrioritySuggestions.filter(s => s.isGroupSuggestion)
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang='less'>
@import (reference) url("../../assets/common.less");

.modal-container-cont {
    .full;
    pointer-events: none;
    display: block;
    bottom: 0;
    z-index: 4;
}

.modal-container {
    pointer-events: auto;
    margin: auto 75px;
    background: @white;
    border-radius: 25px;
    z-index: 4;
    box-shadow: 5px 5px 5px rgba(0, 0, 0, 0.1);
    transform: translate(0%, -50%);
    display: grid;
    grid-template-rows: 120px 1fr 120px;
    position: absolute;
    top: 50%;
    left: 0;
    right: 0;
    max-height: 95vh;
    min-height:  30vh;
    transition: max-height 0.3s ease-in-out, min-height 0.3s ease-in-out;
    overflow: auto;

    .modal-title {
        background-color: @primary-color;
        height: 120px;
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 25px 25px 0px 0px;

        h2 {
            font-size: 40px;
            color: @white;
        }
    }

    .body-container {
        .group-container {
            .group-title {
                margin: 20px 50px;

                h2 {
                    font-size: 35px;
                    color: @primary-dark;
                    text-align: center;
                    margin: 0;
                }
            }

            .prod-cards {
                display: flex;
                flex-direction: row;
                flex-wrap: wrap;
                align-items: center;
                margin-bottom: 20px;
                justify-content: space-evenly;
                overflow: auto;
                max-height: 680px;

                .prod_item {
                    width: 230px;
                    height: 260px;
                    background-color: @white;
                    text-align: center;
                    margin: 20px;
                    box-shadow: 5px 5px 5px rgba(0, 0, 0, 0.1);
                    border-radius: 5px;
                    display: grid;
                    grid-template-rows: 120px 80px 60px;

                    &.prod_item--product {
                        height: 260px;
                        grid-template-rows: 100px 60px 30px 50px;

                        .img_container img {
                            max-height: 100px;
                        }

                        .name_container {
                            height: 60px;
                        }

                        .price_container .from {
                            padding-top: 5px;
                        }

                        .action_container {
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            padding: 0 15px;

                            .btn-add {
                                width: 100%;
                                height: 36px;
                                background-color: @primary-color;
                                color: @white;
                                border: none;
                                border-radius: 10px;
                                font-size: 1.1rem;
                                cursor: pointer;
                                font-family: @default-font;
                                &:active {
                                    opacity: 0.8;
                                }
                            }
                        }
                    }

                    .container {
                        position: absolute;
                        left: 50%;
                        top: 50%;
                        transform: translate(-50%, -50%);
                        width: calc(100% - 30px);
                        padding: 0 15px;
                    }

                    .img_container {
                        img {
                            object-fit: contain;
                            width: 100%;
                            max-height: 120px;
                            height: auto;
                            margin: auto;
                            margin-top: 0;
                            display: block;
                        }
                    }

                    .name_container {
                        position: relative;
                        height: 80px;
                        .name {
                            font-family: @default-font;
                            font-size: 1.2rem;
                            display: block;
                            max-width: 100%;
                            // text-transform: uppercase;
                            text-align: center;
                            margin: auto;
                            padding: 0;
                        }
                    }

                    .price_container {
                        position: relative;

                        .from {
                            text-transform: uppercase;
                            font-size: 1rem;
                            color: @primary-dark;
                            padding-top: 15px;
                        }

                        .price {
                            font-family: @default-font;
                            font-size: 1.2rem;
                            color: var(--price-font-color);
                            margin: 0;
                        }
                    }
                }
            }
        }
    }
    .footer {
        display: flex;
        justify-content: space-evenly;
        align-items: center;
        padding: 0 20px;
        .button-default {
            width: 45%;
        }
    }
}

@media (max-width: 698px) {

    // Gertec SK210
    .modal-container {
        margin: auto 40px;

        .modal-title {
            height: 50px;

            h2 {
                font-size: 20px;
            }
        }

        .prod-cards {
            max-height: 300px;
            .prod_item {
                width: 160px;
                height: 150px;
                margin: 15px 5px;
                grid-template-rows: 80px 40px 30px;

                &.slimMode {
                    box-shadow: unset;
                    grid-template-rows: 80px 40px 30px;
                }

                .img_container {
                    img {
                        max-height: 70px;
                        margin-top: 7px;
                    }
                }

                .name_container {
                    .name {
                        font-size: 12px;
                    }
                }

                .price_container {
                    margin-bottom: 5px;

                    .from {
                        font-size: 10px;
                        padding-top: 0;
                    }

                    .price {
                        font-size: 12px;
                    }
                }
            }
        }
    }
}

@media (min-width: 699px) and (max-width: 1025px) {

    //@tablet
    .modal-container {
        .modal-title {
            height: 100px;

            h2 {
                font-size: 30px;
            }
        }

        .prod-cards {
            max-height: 500px;
            .prod_item {
                width: 175px;
                height: 270px;
                margin: 10px;
                grid-template-rows: 130px 80px 60px;

                .container {
                    width: calc(100% - 30px);
                    padding: 0 15px;
                }

                &.slimMode {
                    box-shadow: unset;
                    grid-template-rows: 130px 70px 50px;
                }

                .img_container {
                    img {
                        max-height: 110px;
                        margin-top: 10px;
                    }
                }

                .name_container {
                    .name {
                        font-size: 1.2rem;
                    }
                }
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/SuggestionsComponents/SuggestionsMenuModal.vue